<template>
  <div>
    <BackToHub />
    <Transition name="fade" mode="out-in">
      <HelloPopup v-if="stage === 0" @click="() => { stage++ }">
        <h1>Привет!</h1>
        <p>
          {{popupText}}
        </p>
      </HelloPopup>
      <SuccessPopup
        v-if="stage === 2"
        :key="3"
        :score="lastTry"
        :max="currentUserStory.maxPoints"
        :achievement="currentUserStory.achievement"
        @click="handleNext"
      />
      <VideoPopup
        v-if="stage === 3"
        @click="handleNext"
        :key="4"
        :video="'https://player.vimeo.com/video/370900759'"
      />
    </Transition>
    <Map
      :active="stage === 1"
      @end="(score) => { handleEnding(score, false) }"
      ref="map"
      :items="currentItems"
      v-if="taskNumber === 0"
      :taskNumber="taskNumber"
      :key="0"
    >
      <svgFirst />
    </Map>
    <Map
      :active="stage === 1"
      @end="(score) => { handleEnding(score, true) }"
      ref="map"
      :items="currentItems"
      v-if="taskNumber === 1"
      :taskNumber="taskNumber"
      :key="1"
    >
      <svgSecond />
    </Map>
  </div>
</template>
<script>
import Map from './components/Map/Map.vue'
import svgFirst from './components/svgFirst.vue'
import svgSecond from './components/svgSecond.vue'
import SuccessPopup from '@/components/SuccessPopup/SuccessPopup.vue'
import HelloPopup from '@/components/HelloPopup/HelloPopup.vue'
import VideoPopup from '@/components/VideoPopup/VideoPopup.vue'
import BackToHub from '@/components/BackToHub/BackToHub.vue'

import { STREET, HOUSE } from '@/services/UserStory'

export default {
  name: 'Lesson1',
  components: {
    Map, SuccessPopup, svgFirst, svgSecond, HelloPopup, VideoPopup, BackToHub,
  },
  props: {
    taskNumber: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    stage(stage) {
      if (stage === 1) {
        this.$userStory.start()
      }
    },
  },
  computed: {
    currentItems() {
      const { taskNumber } = this
      const { grade } = this.$store.state

      if (taskNumber === 0) return require('./assets/map1/items.js').default(grade === 1)
      if (taskNumber === 1) return require('./assets/map2/items.js').default(grade === 1)

      return []
    },
    popupText() {
      if (this.taskNumber === 0) {
        return `Маруся знакомит Запятыню, Скобца и Слэшей с миром больших данных.
Для начала надо осмотреться. В городе находится множество устройств, которые могут собирать полезные данные и анализировать их. Находи активные объекты, изучай информацию про них, отвечай на вопросы и получай баллы. Поехали?`
      }
      return `Ух! Все умные устройства на улице нашли!
«Р-е-ж-и-м детектива» активирован, Запятыню, Скобца и Слешей теперь не остановить. Какие еще умные предметы спрятались рядом?
Продолжим исследование!`
    },
    currentUserStory() {
      if (this.taskNumber === 0) return STREET

      return HOUSE
    },
  },
  methods: {
    handleNext() {
      if (this.taskNumber === 1 && this.stage === 2) {
        this.stage = 3
        return
      }
      this.stage = 0
      this.$userStory.next({ result: this.lastTry })
    },
    handleEnding(score) {
      this.lastTry = score
      this.stage += 1
    },
    restartMap() {
      // restart
      // this.$refs.map.$emit('restart')
      // this.stage = 2
    },
  },
  data() {
    return {
      stage: 0,
      // taskNumber: 0,
      best: 0,
      lastTry: 0,
    }
  },
}
</script>
<style lang="scss" module>
@import './Lesson1.scss';
</style>
